var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"info"}},[_c('a',{attrs:{"href":"http://threejs.org","target":"_blank"}},[_vm._v("three.js")]),_vm._v(" - lines - random ")])}]

export { render, staticRenderFns }